const limiters = new Map();

const getLimiterState = (namespace) => {
  if (!limiters.has(namespace)) {
    limiters.set(namespace, {
      timestamps: [],
      cooldownUntil: 0
    });
  }

  return limiters.get(namespace);
};

export const checkRateLimit = (namespace, { limit, windowMs, cooldownMs }) => {
  const state = getLimiterState(namespace);
  const now = Date.now();

  if (state.cooldownUntil > now) {
    return {
      allowed: false,
      retryAfterMs: state.cooldownUntil - now
    };
  }

  state.timestamps = state.timestamps.filter((timestamp) => now - timestamp < windowMs);

  if (state.timestamps.length >= limit) {
    state.cooldownUntil = now + cooldownMs;
    return {
      allowed: false,
      retryAfterMs: cooldownMs
    };
  }

  state.timestamps.push(now);
  return {
    allowed: true,
    retryAfterMs: 0
  };
};

export const clearRateLimiter = (namespace) => {
  limiters.delete(namespace);
};

export const clearAllRateLimiters = () => {
  limiters.clear();
};
